import { Grid, Container } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";

// Icons
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import TableChartRoundedIcon from "@mui/icons-material/TableChartRounded";


export default function LegalFile() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
      

        {hasPermission("generar cuentas judiciales") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Cargar Archivo"
              subtitle="Migrar cuentas judiciales"
              icon={<ReceiptRoundedIcon />}
              color="#465c89"
              to="/legalFile/judicial/accounts/charge"
            />
          </Grid>
        )}

        {hasPermission("ver cuentas judiciales") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Ver Cuentas Judiciales"
              subtitle="Ver cuentas judiciales cargadas"
              icon={<FolderOpenRoundedIcon />}
              color="#1c8f69"
              to="/legalFile/judicial/accounts/manager"
            />
          </Grid>
        )}

         {hasPermission("reporte cuentas judiciales") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Reporte Cuentas Judiciales"
              subtitle="generar reporte de cuentas judiciales"
              icon={<TableChartRoundedIcon />}
              color="#35a0b1"
              to="/legalFile/judicial/accounts/report"
            />
          </Grid>
        )}

      </Grid>
    </Container>
  );
}
